module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_tvb-d3f69f584451f548b52cc02f5d36e210.svg";